import { render, staticRenderFns } from "./SchUseAppProportion.vue?vue&type=template&id=3944f867&scoped=true"
import script from "./SchUseAppProportion.vue?vue&type=script&lang=js"
export * from "./SchUseAppProportion.vue?vue&type=script&lang=js"
import style0 from "./SchUseAppProportion.vue?vue&type=style&index=0&id=3944f867&prod&lang=scss&scoped=true"
import style1 from "./SchUseAppProportion.vue?vue&type=style&index=1&id=3944f867&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3944f867",
  null
  
)

export default component.exports